import request from '@/utils/request'

// 查询编码分组列表
export function listKsyCodeGroup(query) {
  return request({
    url: '/system/ksyCodeGroup/list',
    method: 'get',
    params: query
  })
}

// 查询编码分组详细
export function getKsyCodeGroup(id) {
  return request({
    url: '/system/ksyCodeGroup/' + id,
    method: 'get'
  })
}

// 新增编码分组
export function addKsyCodeGroup(data) {
  return request({
    url: '/system/ksyCodeGroup',
    method: 'post',
    data: data
  })
}

// 修改编码分组
export function updateKsyCodeGroup(data) {
  return request({
    url: '/system/ksyCodeGroup',
    method: 'put',
    data: data
  })
}

// 删除编码分组
export function delKsyCodeGroup(id) {
  return request({
    url: '/system/ksyCodeGroup/' + id,
    method: 'delete'
  })
}

// 导出编码分组
export function exportKsyCodeGroup(query) {
  return request({
    url: '/system/ksyCodeGroup/export',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/ksyCodeGroup.js